import { render, staticRenderFns } from "./SpecialPrice.vue?vue&type=template&id=6fd54956&scoped=true"
import script from "./SpecialPrice.vue?vue&type=script&lang=js"
export * from "./SpecialPrice.vue?vue&type=script&lang=js"
import style0 from "./SpecialPrice.vue?vue&type=style&index=0&id=6fd54956&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd54956",
  null
  
)

export default component.exports